"use client";

import { c as _c } from "react/compiler-runtime";
import { Footer, spacing, typography, lightColors, Spinner } from "@ops-gsic/cxp-component-library-react";
import styled from "styled-components";
import AppHeader from "@/components/app-header";
import { useTranslations } from "next-intl";
import { WithTimeout } from "@/components/with-timeout";
import { useProfile } from "@/context/ProfileProvider";
import { useInbox } from "@/context/InboxProvider";
// import { mockInbox } from "@/mocks/mockInbox";

type ClientLayoutProps = {
  children: React.ReactNode;
};
const PageShell = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto auto 1fr auto;
  margin: ${spacing.spacing0};
  padding: ${spacing.spacing0};
  background-color: ${lightColors.background};
  color: ${lightColors.textPrimary};
  font-family: ${typography.fontPrimary};
`;
export default function ClientLayout(t0) {
  const $ = _c(23);
  const {
    children
  } = t0;
  const t = useTranslations("Common.components.Footer");
  const {
    profile,
    loading: profileLoading
  } = useProfile();
  const {
    messages,
    unreadCount,
    loading: inboxLoading
  } = useInbox();
  const loading = profileLoading || inboxLoading;
  let t1;
  if ($[0] !== t) {
    t1 = t.raw("links");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const linksRaw = t1 as Record<string, {
    text: string;
    href: string;
  }>;
  let t2;
  if ($[2] !== linksRaw) {
    t2 = Object.values(linksRaw).map(_temp);
    $[2] = linksRaw;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const footerLinks = t2;
  if (loading) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Spinner isLoading={true} />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== messages || $[6] !== profile || $[7] !== unreadCount) {
    t3 = <AppHeader profile={profile} messages={messages} unreadCount={unreadCount} />;
    $[5] = messages;
    $[6] = profile;
    $[7] = unreadCount;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("copyright.text");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("copyright.href");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = {
      text: t4,
      href: t5
    };
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== footerLinks || $[17] !== t6) {
    t7 = <Footer footerLinks={footerLinks} printerLink={t6} />;
    $[16] = footerLinks;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== children || $[20] !== t3 || $[21] !== t7) {
    t8 = <WithTimeout requireAuthentication={false}><PageShell>{t3}{children}{t7}</PageShell></WithTimeout>;
    $[19] = children;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
function _temp(link) {
  return {
    text: link.text,
    href: link.href
  };
}